import * as React from 'react';
import { Typography, IconButton } from '@mui/material';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import DeleteIcon from '@mui/icons-material/Delete';

import {
    UploadCardWrapper,
    FileIconWrapper,
    FileInfoWrapper,
    StyledLinearProgress,
} from './FileUploadCard.styles';

export default function FileUploadCard({ file, onRemove, onCompleteUpload }) {
    const [progress, setProgress] = React.useState(0);
    const [buffer, setBuffer] = React.useState(10);
    const [completed, setCompleted] = React.useState(false);

    React.useEffect(() => {
        const timer = setInterval(() => {
            setProgress(prev => {
                const next = prev >= 100 ? 100 : prev + 2;

                if (next === 100 && !completed) {
                    setCompleted(true);
                    if (onCompleteUpload) onCompleteUpload();
                }

                return next;
            });

            setBuffer(prev => (prev >= 100 ? 100 : prev + 3));
        }, 200);

        return () => clearInterval(timer);
    }, [onCompleteUpload, completed]); // Removed 'completed' from dependencies

    return (
        <UploadCardWrapper>
            <FileIconWrapper>
                <InsertDriveFileIcon color="primary" />
            </FileIconWrapper>

            <FileInfoWrapper>
                <Typography variant="body2" fontWeight="bold" noWrap>
                    {file.filename || file.name || 'Unknown file'}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                    {Math.round(file.size / 1024)}kb • {progress < 100 ? 'Uploading' : 'Completed'}
                </Typography>
                <StyledLinearProgress
                    variant="buffer"
                    value={progress}
                    valueBuffer={buffer}
                />
            </FileInfoWrapper>

            <IconButton size="small" onClick={onRemove}>
                <DeleteIcon fontSize="small" />
            </IconButton>
        </UploadCardWrapper>
    );
}
